@if (products?.length) {
  <div class="col-12">
    @if (facade.underlyingIsin$ | async; as underlyingIsin) {
      @if (facade.productType$ | async; as productType) {
        @if (facade.currentDerivativeType$ | async; as currentDerivativeType) {
          <div class="row pt-2 pb-2">
            @switch (currentDerivativeType) {
              @case ('knockout') {
                <div class="col-3 pl-0 zero-text p-small-med">{{ 'leverage-products.list.leverage' | transloco }}</div>
                <div class="col-3 text-right zero-text p-small-med">{{ 'leverage-products.list.ko' | transloco }}</div>
                <div class="col-3 text-right zero-text p-small-med">
                  {{ 'leverage-products.list.issuer' | transloco }} / {{ 'leverage-products.list.ask' | transloco }}
                </div>
                <div class="col-3 pr-0 text-right zero-text p-small-med">
                  {{ 'leverage-products.list.term' | transloco }}
                </div>
              }
              @case ('optionsscheine') {
                <div class="col-6 pl-0 zero-text p-small-med">{{ 'leverage-products.list.strike' | transloco }}</div>
                <div class="col-3 text-right zero-text p-small-med">
                  {{ 'leverage-products.list.issuer' | transloco }} / {{ 'leverage-products.list.ask' | transloco }}
                </div>
                <div class="col-3 pr-0 text-right zero-text p-small-med">
                  {{ 'leverage-products.list.term' | transloco }}
                </div>
              }
              @case ('factor') {
                <div class="col-3 pl-0 zero-text p-small-med">{{ 'leverage-products.list.factor' | transloco }}</div>
                <div class="col-3 text-right zero-text p-small-med">{{ 'leverage-products.list.strike' | transloco }}</div>
                <div class="col-3 text-right zero-text p-small-med">
                  {{ 'leverage-products.list.issuer' | transloco }} / {{ 'leverage-products.list.ask' | transloco }}
                </div>
                <div class="col-3 pr-0 text-right zero-text p-small-med">
                  {{ 'leverage-products.list.term' | transloco }}
                </div>
              }
              @case ('discount') {
                <div class="hidden-xs col-1 pl-0 zero-text p-small-med">{{ 'leverage-products.list.cap' | transloco }}</div>
                <div class="hidden-xs col-2 text-right zero-text p-small-med">
                  {{ 'leverage-products.list.discount' | transloco }}
                </div>
                <div class="hidden-xs col-2 text-right zero-text p-small-med">
                  {{ 'leverage-products.list.maxreturn' | transloco }}
                </div>
                <div class="hidden-xs col-3 text-right zero-text p-small-med">
                  {{ 'leverage-products.list.sidereturn' | transloco }}
                </div>
                <div class="hidden-xs col-2 text-right zero-text p-small-med">
                  {{ 'leverage-products.list.issuer' | transloco }} / {{ 'leverage-products.list.ask' | transloco }}
                </div>
                <div class="hidden-xs col-2 pr-0 text-right zero-text p-small-med">{{ 'leverage-products.list.term' | transloco }}</div>
              }
            }
          </div>
          @if (facade.highlightedProduct$ | async; as highlightedProduct) {
            <a
              class="row link-black pt-2 pb-2 border-top cursor-pointer product ad"
              [routerLink]="orderMask"
              [queryParams]="highlightedProduct | trackingQueryParams: 'row' : 0 : currentDerivativeType : productType : underlyingIsin"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div class="col-6 pl-0 mb-1 zero-text p-xsmall-med">{{ highlightedProduct.name }}</div>
              <div class="col-3 text-right zero-text p-xsmall-med">
                <ng-container *ngTemplateOutlet="issuer; context: { product: highlightedProduct }" />
              </div>
              <div class="col-3 zero-text p-xsmall-med text-right pr-3">
                <ng-container
                  *ngTemplateOutlet="
                    moreLink;
                    context: { product: highlightedProduct, pos: 0, type: currentDerivativeType, productType, underlyingIsin }
                  "
                />
              </div>
              <div class="col-3 pl-0 zero-text p-base-bold">{{ highlightedProduct.leverage | number }}</div>
              <div class="col-3 text-right zero-text p-base-med">{{ highlightedProduct.ko | number: '1.2-2' }}</div>
              <div class="col-3 text-right zero-text p-base-med">{{ highlightedProduct.ask | number: '1.2-2' }}</div>
              <div class="col-3 pr-3 text-right zero-text p-xsmall-med" [innerHTML]="highlightedProduct.maturity | openEnd"></div>
              <div class="label zero-text disabled">{{ 'leverage-products.list.ad' | transloco }}</div>
            </a>
          }
          @for (product of products; track product.isin; let i = $index) {
            <a
              class="row link-black pt-2 pb-2 border-top cursor-pointer product"
              [routerLink]="orderMask"
              [queryParams]="product | trackingQueryParams: 'row' : i + 1 : currentDerivativeType : productType : underlyingIsin"
              target="_blank"
              rel="noopener noreferrer"
            >
              @switch (currentDerivativeType) {
                @case ('knockout') {
                  <div class="col-6 pl-0 mb-1 zero-text p-xsmall-med">{{ product.name }}</div>
                  <div class="col-3 text-right zero-text p-xsmall-med">
                    <ng-container *ngTemplateOutlet="issuer; context: { product: product }" />
                  </div>
                  <div class="col-3 zero-text p-xsmall-med text-right pr-3">
                    <ng-container
                      *ngTemplateOutlet="
                        moreLink;
                        context: { product: product, pos: i + 1, type: currentDerivativeType, productType, underlyingIsin }
                      "
                    />
                  </div>
                  <div class="col-3 pl-0 zero-text p-base-bold">{{ product.leverage | number }}</div>
                  <div class="col-3 text-right zero-text p-base-med">{{ product.ko | number: '1.2-2' }}</div>
                  <div class="col-3 text-right zero-text p-base-med">{{ product.ask | number: '1.2-2' }}</div>
                  <div class="col-3 pr-3 text-right zero-text p-xsmall-med" [innerHTML]="product.maturity | openEnd"></div>
                }
                @case ('optionsscheine') {
                  <div class="col-6 pl-0 mb-1 zero-text p-xsmall-med">{{ product.name }}</div>
                  <div class="col-3 zero-text p-xsmall-med text-right">
                    <ng-container *ngTemplateOutlet="issuer; context: { product: product }" />
                  </div>
                  <div class="col-3 zero-text p-xsmall-med text-right pr-0">
                    <ng-container
                      *ngTemplateOutlet="
                        moreLink;
                        context: { product: product, pos: i + 1, type: currentDerivativeType, productType, underlyingIsin }
                      "
                    />
                  </div>
                  <div class="col-6 pl-0 zero-text p-base-bold">{{ product.strike | number }}</div>
                  <div class="col-3 text-right zero-text p-base-med">{{ product.ask | number: '1.2-2' }}</div>
                  <div class="col-3 pr-0 text-right zero-text p-base-med" [innerHTML]="product.maturity | openEnd"></div>
                }
                @case ('factor') {
                  <div class="col-6 pl-0 mb-1 zero-text p-xsmall-med">{{ product.name }}</div>
                  <div class="col-3 zero-text p-xsmall-med text-right">
                    <ng-container *ngTemplateOutlet="issuer; context: { product: product }" />
                  </div>
                  <div class="col-3 zero-text p-xsmall-med text-right pr-0">
                    <ng-container
                      *ngTemplateOutlet="
                        moreLink;
                        context: { product: product, pos: i + 1, type: currentDerivativeType, productType, underlyingIsin }
                      "
                    />
                  </div>
                  <div class="col-3 pl-0 zero-text p-base-bold">{{ product.factor | number }}</div>
                  <div class="col-3 text-right zero-text p-base-med">{{ product.strike | number: '1.2-2' }}</div>
                  <div class="col-3 text-right zero-text p-base-med">{{ product.ask | number: '1.2-2' }}</div>
                  <div class="col-3 pr-0 text-right zero-text p-base-mede" [innerHTML]="product.maturity | openEnd"></div>
                }
                @case ('discount') {
                  <div class="col-12 col-sm-8 pl-0 mb-1 zero-text p-xsmall-med">{{ product.name }}</div>
                  <div class="col-sm-2 zero-text p-xsmall-med">
                    <div class="row">
                      <div class="col-6 pl-0 hidden-sm hidden-md hidden-lg hidden-xl">Emittent:</div>
                      <div class="col-6 col-sm-12 text-right pr-0 pr-sm-3">
                        <ng-container *ngTemplateOutlet="issuer; context: { product: product }" />
                      </div>
                    </div>
                  </div>
                  <div class="hidden-xs col-sm-2 zero-text p-xsmall-med text-right pr-0">
                    <ng-container
                      *ngTemplateOutlet="
                        moreLink;
                        context: { product: product, pos: i + 1, type: currentDerivativeType, productType, underlyingIsin }
                      "
                    />
                  </div>
                  <div class="col-sm-1 pl-0">
                    <div class="row">
                      <div class="col-6 hidden-sm hidden-md hidden-lg hidden-xl">Cap:</div>
                      <div class="col-6 col-sm-12 text-right text-sm-left zero-text p-base-bold pr-0 pr-sm-3">
                        {{ product.cap | number }}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="row">
                      <div class="col-6 pl-0 hidden-sm hidden-md hidden-lg hidden-xl">
                        {{ 'leverage-products.list.discount' | transloco }}:
                      </div>
                      <div class="col-6 col-sm-12 text-right pr-0 pr-sm-3 zero-text p-base-med">{{ product.discount | number }} %</div>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="row">
                      <div class="col-6 pl-0 hidden-sm hidden-md hidden-lg hidden-xl">
                        {{ 'leverage-products.list.maxreturn' | transloco }}:
                      </div>
                      <div class="col-6 col-sm-12 text-right pr-0 pr-sm-3 zero-text p-base-med">
                        {{ product.maxreturn | number: '1.2-2' }} %
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="row">
                      <div class="col-6 pl-0 hidden-sm hidden-md hidden-lg hidden-xl">
                        {{ 'leverage-products.list.sidereturn' | transloco }}:
                      </div>
                      <div class="col-6 col-sm-12 text-right pr-0 pr-sm-3 zero-text p-base-med">
                        {{ product.sidereturn_pa | number: '1.2-2' }} %
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="row">
                      <div class="col-6 pl-0 hidden-sm hidden-md hidden-lg hidden-xl">{{ 'leverage-products.list.ask' | transloco }}:</div>
                      <div class="col-6 col-sm-12 text-right pr-0 pr-sm-3 zero-text p-base-med">{{ product.ask | number: '1.2-2' }}</div>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="row">
                      <div class="col-6 pl-0 hidden-sm hidden-md hidden-lg hidden-xl">{{ 'leverage-products.list.term' | transloco }}:</div>
                      <div class="col-6 col-sm-12 text-right pr-0 zero-text p-base-med" [innerHTML]="product.maturity | openEnd"></div>
                    </div>
                  </div>
                }
              }
            </a>
          }
        }
      }
    }
  </div>
} @else {
  <div class="row" data-zid="no-products">
    <div class="col-12">{{ 'leverage-products.list.no-products' | transloco }}</div>
  </div>
}

<ng-template #issuer let-product="product">
  @if (ISSUER_MAPPING[product.emittent]) {
    {{ ISSUER_MAPPING[product.emittent] }}
  } @else {
    {{ product.emittent }}
  }
</ng-template>

<ng-template
  #moreLink
  let-product="product"
  let-pos="pos"
  let-type="type"
  let-productType="productType"
  let-underlyingIsin="underlyingIsin"
>
  <a
    [routerLink]="[instrumentDetail, product.isin]"
    [queryParams]="product | trackingQueryParams: 'more' : pos : type : productType : underlyingIsin"
    class="link-black underline-hover"
  >
    {{ 'leverage-products.list.more-info' | transloco }}
  </a>
</ng-template>
